import React, { useEffect } from 'react';
import { match, useHistory } from 'react-router';
import Modal from 'components/utility/Modal/Modal';
import AcceptInvite from 'components/customlists/AcceptInvite';
import { logToAmplitude } from 'helpers/logAmplitudeEvent';

interface ICustomListInvitationMatchParams {
  id: string;
  inviteId: string;
}

interface ICustomListInvitationProps {
  match: match<ICustomListInvitationMatchParams>;
}

const CustomListInvitation: React.FC<ICustomListInvitationProps> = (props) => {
  useEffect(() => {
    logToAmplitude(
      'User has opened the invitation to be a curator in the List'
    );
  }, []);

  const { match } = props;
  const { id, inviteId } = match.params;
  const history = useHistory();

  const close = (): void => {
    history.push(`/list/${id}`);
  };

  return (
    <Modal canClickOutside={false}>
      <AcceptInvite listId={id} invitationId={inviteId} close={close} />
    </Modal>
  );
};

export default CustomListInvitation;
